import { createContext, useContext } from 'react';

import { CountryContextType } from 'context/types';

const CountryContext = createContext(null);

export const useCountryContext = (): CountryContextType => useContext(CountryContext);

export default CountryContext;
